import React from 'react'
import { Loading } from '@marketing-milk/frontend'
import { useSprint } from 'hooks/api/useSprint'
import { SprintDraftCampaigns } from '../sprint-campaigns-tab/SprintDraftCampaigns'
import { SprintsCreativesTab } from '../sprint-creatives-tab/SprintsCreativesTab'
import { SprintsPublishedCampaigns } from '../sprint-published-campaigns/SprintPublishedCampaigns'

export type SprintTab = 'creatives' | 'draft-campaigns' | 'published-campaigns'

type Props = {
  selectedSprintId: number
  tab: SprintTab
  navigation: React.ReactNode
}

export const SprintContent = ({ selectedSprintId, tab, navigation }: Props) => {
  const { sprint, sprintCreatives } = useSprint(selectedSprintId)

  if (sprint && tab === 'creatives') {
    return <SprintsCreativesTab sprintId={sprint.id} navigation={navigation} />
  }

  return (
    <>
      <div className="flex flex-shrink-0 items-center border-b border-mm-neutral-1-200 bg-white px-4">
        {navigation}
      </div>
      <div
        role="tabpanel"
        id={`sprint-panel-${tab}`}
        aria-labelledby={`sprint-tab-${tab}`}
        tabIndex={0}
        className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-mm-neutral-2-50"
      >
        {!sprint ? (
          <Loading loadingMessage="Loading sprint…" />
        ) : (
          <>
            {tab === 'draft-campaigns' && (
              <SprintDraftCampaigns sprint={sprint} creatives={sprintCreatives} />
            )}
            {tab === 'published-campaigns' && <SprintsPublishedCampaigns sprintId={sprint.id} />}
          </>
        )}
      </div>
    </>
  )
}
